module.exports = __webpack_public_path__ + "static/img/3.4ee1b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/milan/3.png
// module id = vc3h
// module chunks = 1